var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 70.9999C33 70.9999 39.4693 76.5896 50.3204 76.5318C61.1714 76.474 67 71 67 71",
    stroke: "#6EB854",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9992 100C22.4295 100 0 77.5697 0 49.9992C0 22.4295 22.4295 0 49.9992 0C77.5688 0 99.9984 22.4295 99.9984 49.9992C99.9984 77.5697 77.5688 100 49.9992 100ZM49.9992 4.93137C25.1492 4.93137 4.93137 25.1492 4.93137 49.9992C4.93137 74.85 25.1492 95.0686 49.9992 95.0686C74.8492 95.0686 95.067 74.85 95.067 49.9992C95.067 25.1492 74.8492 4.93137 49.9992 4.93137Z",
    fill: "#6EB854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0502 56.8748C25.8468 56.8748 28.9246 53.797 28.9246 50.0004C28.9246 46.2037 25.8468 43.126 22.0502 43.126C18.2535 43.126 15.1758 46.2037 15.1758 50.0004C15.1758 53.797 18.2535 56.8748 22.0502 56.8748Z",
    fill: "#6EB854"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9506 56.8748C81.7472 56.8748 84.825 53.797 84.825 50.0004C84.825 46.2037 81.7472 43.126 77.9506 43.126C74.1539 43.126 71.0762 46.2037 71.0762 50.0004C71.0762 53.797 74.1539 56.8748 77.9506 56.8748Z",
    fill: "#6EB854"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.bf025616bac25326f79dcd730c9a6961.svg";
export { ForwardRef as ReactComponent };